import { default as MuiList, ListProps as MuiListProps } from '@mui/material/List';
import { ResponsiveStyleValue } from '@mui/system';
import { forwardRef } from 'react';
import Stack from '@mui/material/Stack';

export interface ListProps extends MuiListProps {
  spacing?: ResponsiveStyleValue<number | string>;
}

// ToDo: refactor it using import { createUnarySpacing } from '@mui/system'; instead of hardcoded Stack component?
const List = forwardRef<HTMLUListElement, ListProps>((props, ref) => {
  const { children, spacing = 0, ...other } = props;

  return (
    <MuiList ref={ref} {...other}>
      {spacing && spacing !== 0 ? <Stack spacing={spacing}>{children}</Stack> : children}
    </MuiList>
  );
});

List.displayName = 'List';

export default List;
